import block from '@/mixins/block'

export default {
  name: 'block_gallery',
  mixins: [block],
  mounted () {
    this.$nextTick(() => {
      if (this.$store.state.ua.platform.type !== 'desktop') {
        let wrapper = this.$refs['block-gallery-carroussel-item-wrapper']
        let image = wrapper.querySelector('.block-gallery-carroussel-item')
        wrapper.style.width = (image.offsetWidth * 3 + (image.offsetWidth / 5 * 2)) + 'px'
      }
    })
  }
}
